export function openReserveFiltrate (options) {
    return new Promise((resolve, reject) => {
        app.router.push("/reserveListFiltrate", route => {
            route.meta._resolve = resolve
            route.meta._reject = reject
            route.meta.options = options
        }, err => {
            console.log(err);
        })
    })
}